import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import ShrimpTopupRecord from '../ShrimpTopupRecord'

const ShrimpTopup = () => {
  return (
    <Box sx={{ py: 3 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ShrimpTopupRecord />
        </Grid>
      </Grid>
    </Box>
  )
}

export default ShrimpTopup
